import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import StatsBar from './components/StatsBar';
import BottomNavigation from './components/BottomNavigation';
import ModeSelector from './components/ModeSelector';
import VocabularyCard from './components/VocabularyCard';
import LanguageSettings from './components/LanguageSettings';
import StudyMode from './components/StudyMode';
import TestMode from './components/TestMode';
import FeaturesSection from './components/FeaturesSection';
import LearningPathPage from './components/LearningPathPage';
import UnitDetailPage from './components/UnitDetailPage';
import RoleplayPage from './components/RoleplayPage';
import RoleplayScenarioPage from './components/RoleplayScenarioPage';
import UnitStudyingPage from './components/UnitStudyingPage';
import TutorVoicePage from './components/TutorVoicePage';
import ToneLearningUnitsPage from './components/ToneLearningUnitsPage';
import ToneUnitDetailPage from './components/ToneUnitDetailPage';
import BilingualTutorPage from './components/BilingualTutorPage';
import BilingualTutorSessionPage from './components/BilingualTutorSessionPage';
import LearningCyclePage from './components/LearningCyclePage';
import LearningPackagesPage from './components/LearningPackagesPage';
import AIFeedbackPage from './components/AIFeedbackPage';
import CertifiedCoursesPage from './components/CertifiedCoursesPage';
import DailyChallengesPage from './components/DailyChallengesPage';
import AchievementsPage from './components/AchievementsPage';
import CommunityLearningPage from './components/CommunityLearningPage';
import ARPracticePage from './components/ARPracticePage';
import AILearningAssistantPage from './components/AILearningAssistantPage';
import OfflineLearningPage from './components/OfflineLearningPage';
import LearningJourneyPage from './components/LearningJourneyPage';
import TutorVoiceSelectionPage from './components/TutorVoiceSelectionPage';
// Old voice selection modal no longer needed - using VoiceSelector instead
// import TutorVoiceSelectionModal from './components/TutorVoiceSelectionModal';
import GrammarTopicsPage from './components/GrammarTopicsPage';
import GrammarTopicLearningPage from './components/GrammarTopicLearningPage';
import PurchasedCoursesSection from './components/PurchasedCoursesSection';
import GrammarBookPage from './components/GrammarBookPage';
import IELTSStudyPage from './components/IELTSStudyPage';
import TOEFLStudyPage from './components/TOEFLStudyPage';
import MySchoolBookPage from './components/MySchoolBookPage';
import ComponentsCatalogPage from './components/ComponentsCatalogPage';
import { userData, userProgress } from './data/userProgress';
import { vocabularyData, vocabularyCategories } from './data/vocabulary';
import { grammarTopics, dailyChallenges } from './data/lessons';
import DailyChallenge from './components/DailyChallenge';
import ProgressTracker from './components/ProgressTracker';
import VoiceQualityTester from './components/VoiceQualityTester';
import VoiceSelector from './components/VoiceSelector';
import SidebarNav from './components/SidebarNav';
import A2AServerToggle from './components/A2AServerToggle';

function App() {
  const [currentView, setCurrentView] = useState('home');
  const [currentMode, setCurrentMode] = useState('read');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [showLanguageSettings, setShowLanguageSettings] = useState(false);
  const [userPreferences, setUserPreferences] = useState(userData.preferences);
  const [dailyWord, setDailyWord] = useState(null);
  const [showDailyChallenge, setShowDailyChallenge] = useState(false);
  const [showProgressTracker, setShowProgressTracker] = useState(false);
  const [selectedUnitId, setSelectedUnitId] = useState(null);
  const [selectedScenarioId, setSelectedScenarioId] = useState(null);
  const [selectedToneUnitId, setSelectedToneUnitId] = useState(null);
  const [selectedBilingualSessionId, setSelectedBilingualSessionId] = useState(null);
  const [currentLearningCycleView, setCurrentLearningCycleView] = useState(null);
  const [currentDailyChallengesView, setCurrentDailyChallengesView] = useState(null);
  const [currentCommunityLearningView, setCurrentCommunityLearningView] = useState(null);
  const [showAILearningAssistant, setShowAILearningAssistant] = useState(false);
  const [showOfflineLearning, setShowOfflineLearning] = useState(false);
  const [showTutorVoiceSelection, setShowTutorVoiceSelection] = useState(false);
  const [currentGrammarGroupId, setCurrentGrammarGroupId] = useState(null);
  const [currentGrammarTopicId, setCurrentGrammarTopicId] = useState(null);
  const [currentGrammarMode, setCurrentGrammarMode] = useState('read');
  const [currentPurchasedCourse, setCurrentPurchasedCourse] = useState(null);
  const [showVoiceQualityTester, setShowVoiceQualityTester] = useState(false);
  const [showVoiceSelector, setShowVoiceSelector] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  // Get daily vocabulary word
  useEffect(() => {
    const getRandomWord = () => {
      const categories = Object.keys(vocabularyData);
      const randomCategory = categories[Math.floor(Math.random() * categories.length)];
      const words = vocabularyData[randomCategory];
      const randomWord = words[Math.floor(Math.random() * words.length)];
      return { ...randomWord, category: randomCategory };
    };

    if (!dailyWord) {
      setDailyWord(getRandomWord());
    }
  }, [dailyWord]);

  const handlePreferencesChange = (key, value) => {
    setUserPreferences(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleAILearningAssistantClick = () => {
    setShowAILearningAssistant(true);
  };

  const handleBackFromAILearningAssistant = () => {
    setShowAILearningAssistant(false);
  };

  const handleVoiceQualityTesterClick = () => {
    setShowVoiceQualityTester(true);
  };

  const handleBackFromVoiceQualityTester = () => {
    setShowVoiceQualityTester(false);
  };

  const handleVoiceSelectorClick = () => {
    setShowVoiceSelector(true);
  };

  const handleVoiceSelectorClose = () => {
    setShowVoiceSelector(false);
  };

  const handleVoiceChange = (selectedVoiceId) => {
    console.log('Voice changed to:', selectedVoiceId);
    // The voice is already saved in localStorage by the VoiceSelector
    // You can add additional logic here if needed
  };

  const handleOfflineModeClick = () => {
    setShowOfflineLearning(true);
  };

  const handleBackFromOfflineLearning = () => {
    setShowOfflineLearning(false);
  };

  const handleTutorVoiceSelectionClick = () => {
    setShowTutorVoiceSelection(true);
  };

  const handleBackFromTutorVoiceSelection = () => {
    setShowTutorVoiceSelection(false);
  };

  // Old voice modal functions removed - VoiceSelector handles its own state

  const handleGrammarTopicsClick = () => {
    setCurrentView('grammar_topics');
  };

  const handleBackFromGrammarTopics = () => {
    setCurrentView('home');
  };

  const handleNavigateToGrammarTopic = (groupId, topicId, mode) => {
    setCurrentGrammarGroupId(groupId);
    setCurrentGrammarTopicId(topicId);
    setCurrentGrammarMode(mode);
    setCurrentView('grammar_topic_learning');
  };

  const handleBackFromGrammarTopicLearning = () => {
    setCurrentView('grammar_topics');
  };

  const handleGrammarModeChange = (newMode) => {
    setCurrentGrammarMode(newMode);
  };

  // Purchased Courses Handlers
  const handlePurchasedCourseClick = (courseId) => {
    setCurrentPurchasedCourse(courseId);
    setCurrentView('purchased_course');
  };

  const handleBackFromPurchasedCourse = () => {
    setCurrentPurchasedCourse(null);
    setCurrentView('home');
  };



  const getCurrentWords = () => {
    if (!selectedCategory) return [];
    return vocabularyData[selectedCategory] || [];
  };

  const currentWords = getCurrentWords();
  const currentWord = currentWords[currentWordIndex];

  const handleNextWord = () => {
    if (currentWordIndex < currentWords.length - 1) {
      setCurrentWordIndex(currentWordIndex + 1);
    }
  };

  const handlePrevWord = () => {
    if (currentWordIndex > 0) {
      setCurrentWordIndex(currentWordIndex - 1);
    }
  };

  // Learning Path Handlers
  const handleFeatureClick = (feature) => {
    if (feature.id === 'personalized_learning') {
      setCurrentView('unit_studying');
    } else if (feature.id === 'game_mode_courses') {
      setCurrentView('roleplay');
    } else if (feature.id === 'accent_selection') {
      handleVoiceSelectorClick();
    } else if (feature.id === 'voice_quality_tester') {
      handleVoiceQualityTesterClick();
    } else if (feature.id === 'ar_practice') {
      setCurrentView('ar_practice');
    } else if (feature.id === 'bilingual_tutor_system') {
      setCurrentView('bilingual_tutor');
    } else if (feature.id === 'grammar_topics') {
      handleGrammarTopicsClick();
    } else if (feature.id === 'voice_selector') {
      handleVoiceSelectorClick();
    } else if (feature.id === 'practical_communication') {
      setCurrentView('learning_cycle');
      setCurrentLearningCycleView('cycle');
    } else if (feature.id === 'daily_challenges') {
      setCurrentView('daily_challenges');
      setCurrentDailyChallengesView('challenges');
    } else if (feature.id === 'community_learning') {
      setCurrentView('community_learning');
    } else {
      console.log('Feature clicked:', feature.id);
      // Handle other features
    }
  };

  const handleSidebarSelect = (id) => {
    switch (id) {
      case 'learning_journey':
        setCurrentView('learning_journey');
        break;
      case 'game_mode_courses':
        setCurrentView('roleplay');
        break;
      case 'voice_selector':
        handleVoiceSelectorClick();
        break;
      case 'bilingual_tutor_system':
        setCurrentView('bilingual_tutor');
        break;
      case 'voice_quality_tester':
        handleVoiceQualityTesterClick();
        break;
      case 'voice_settings':
        setCurrentView('tutor_voice');
        break;
      case 'grammar_topics':
        handleGrammarTopicsClick();
        break;
      case 'practical_communication':
        setCurrentView('learning_cycle');
        setCurrentLearningCycleView('cycle');
        break;
      case 'daily_challenges':
        setCurrentView('daily_challenges');
        setCurrentDailyChallengesView('challenges');
        break;
      case 'ar_practice':
        setCurrentView('ar_practice');
        break;
      case 'community_learning':
        setCurrentView('community_learning');
        break;
      case 'personalized_learning':
        setCurrentView('unit_studying');
        break;
      default:
        break;
    }
  };

  // Components Catalog navigation
  const handleOpenComponent = (pageId) => {
    switch (pageId) {
      case 'features':
        setCurrentView('home');
        break;
      case 'ai_learning_assistant':
        setShowAILearningAssistant(true);
        break;
      case 'grammar_topics':
        setCurrentView('grammar_topics');
        break;
      case 'grammar_book':
        setCurrentPurchasedCourse('grammar_book');
        setCurrentView('purchased_course');
        break;
      case 'learning_paths':
        setCurrentView('learning_path');
        break;
      case 'daily_challenges':
        setCurrentView('daily_challenges');
        setCurrentDailyChallengesView('challenges');
        break;
      case 'roleplay':
        setCurrentView('roleplay');
        break;
      case 'tone_learning':
        setCurrentView('tone_learning_units');
        break;
      case 'ar_practice':
        setCurrentView('ar_practice');
        break;
      case 'community_learning':
        setCurrentView('community_learning');
        break;
      case 'unit_studying':
        setCurrentView('unit_studying');
        break;
      case 'progress_tracker':
        setShowProgressTracker(true);
        break;
      default:
        setCurrentView('home');
    }
  };

  const handleUnitClick = (unitId) => {
    setSelectedUnitId(unitId);
    setCurrentView('unit_detail');
  };



  const handleBackFromLearningPath = () => {
    setCurrentView('home');
  };

  const handleBackFromUnitStudying = () => {
    setCurrentView('home');
  };



  const handleLessonClick = (lessonId) => {
    console.log('Lesson clicked:', lessonId);
    // Handle lesson start - could navigate to actual lesson interface
    setCurrentView('home');
  };

  const handleBackFromUnitDetail = () => {
    setSelectedUnitId(null);
    setCurrentView('learning_path');
  };

  // Roleplay Handlers
  const handleScenarioClick = (scenarioId) => {
    setSelectedScenarioId(scenarioId);
    setCurrentView('roleplay_scenario');
  };

  const handleLabOptionClick = (optionId) => {
    if (optionId === 'surprise_me') {
      // Handle random scenario selection
      const scenarios = ['job_interview', 'bakehouse_conversation', 'chat_with_friend'];
      const randomScenario = scenarios[Math.floor(Math.random() * scenarios.length)];
      setSelectedScenarioId(randomScenario);
      setCurrentView('roleplay_scenario');
    } else if (optionId === 'create_my_own') {
      console.log('Custom scenario creation');
      // Handle custom scenario creation
    }
  };

  const handleStartRoleplay = (scenarioId) => {
    console.log('Starting roleplay for scenario:', scenarioId);
    // Handle roleplay start - could navigate to actual roleplay interface
    setCurrentView('home');
  };

  const handleBackFromRoleplay = () => {
    setCurrentView('home');
  };

  const handleBackFromRoleplayScenario = () => {
    setSelectedScenarioId(null);
    setCurrentView('roleplay');
  };

  // Tutor Voice Handlers
  const handleBackFromTutorVoice = () => {
    setCurrentView('home');
  };

  const handleSaveTutorVoice = (selectedVoices) => {
    console.log('Saving tutor voice selection:', selectedVoices);
    // Handle voice selection save
    if (showTutorVoiceSelection) {
      setShowTutorVoiceSelection(false);
    } else {
      setCurrentView('home');
    }
  };

  // Tone Learning Handlers
  const handleBackFromToneLearningUnits = () => {
    setCurrentView('home');
  };

  const handleToneUnitClick = (unitId) => {
    setSelectedToneUnitId(unitId);
    setCurrentView('tone_unit_detail');
  };

  const handleBackFromToneUnitDetail = () => {
    setSelectedToneUnitId(null);
    setCurrentView('tone_learning_units');
  };

  const handleToneLessonClick = (lessonId) => {
    console.log('Tone lesson clicked:', lessonId);
    // Handle tone lesson start
  };

  // Bilingual Tutor Handlers
  const handleBackFromBilingualTutor = () => {
    setCurrentView('home');
  };

  const handleBilingualSessionClick = (sessionId) => {
    setSelectedBilingualSessionId(sessionId);
    setCurrentView('bilingual_tutor_session');
  };

  const handleBackFromBilingualSession = () => {
    setSelectedBilingualSessionId(null);
    setCurrentView('bilingual_tutor');
  };

  const handleBilingualSessionComplete = (sessionId) => {
    console.log('Bilingual session completed:', sessionId);
    // Handle session completion
    setSelectedBilingualSessionId(null);
    setCurrentView('bilingual_tutor');
  };

  // Learning Cycle Handlers
  const handleBackFromLearningCycle = () => {
    setCurrentView('home');
    setCurrentLearningCycleView(null);
  };

  const handleViewPackages = () => {
    setCurrentLearningCycleView('packages');
  };

  const handleBackFromPackages = () => {
    setCurrentLearningCycleView('cycle');
  };

  const handleViewAIFeedback = () => {
    setCurrentLearningCycleView('ai_feedback');
  };

  const handleViewCertifiedCourses = () => {
    setCurrentLearningCycleView('certified_courses');
  };

  const handleBackFromAIFeedback = () => {
    setCurrentLearningCycleView('packages');
  };

  const handleBackFromCertifiedCourses = () => {
    setCurrentLearningCycleView('packages');
  };

  const handleKeepGoing = () => {
    console.log('Keep going clicked');
    // Handle keep going action
    setCurrentView('home');
    setCurrentLearningCycleView(null);
  };

  const handleStartTraining = () => {
    console.log('Start training clicked');
    // Handle start training action
    setCurrentView('home');
    setCurrentLearningCycleView(null);
  };

  // Daily Challenges Handlers
  const handleBackFromDailyChallenges = () => {
    setCurrentView('home');
    setCurrentDailyChallengesView(null);
  };

  const handleLeaderboardClick = () => {
    console.log('Leaderboard clicked');
    // Handle leaderboard navigation
    setCurrentView('home');
    setCurrentDailyChallengesView(null);
  };

  const handleAchievementsClick = () => {
    setCurrentDailyChallengesView('achievements');
  };

  const handleBackFromAchievements = () => {
    setCurrentDailyChallengesView('challenges');
  };

  const handleChallengeStart = (challengeId) => {
    console.log('Starting challenge:', challengeId);
    // Handle challenge start
    setCurrentView('home');
    setCurrentDailyChallengesView(null);
  };

  const handleShareAchievement = () => {
    console.log('Sharing achievement');
    // Handle achievement sharing
    setCurrentView('home');
    setCurrentDailyChallengesView(null);
  };

  // Community Learning Handlers
  const handleBackFromCommunityLearning = () => {
    setCurrentView('home');
  };





  const handleBackFromStandaloneARPractice = () => {
    setCurrentView('home');
  };

  const handleStartScanning = () => {
    console.log('Start scanning clicked');
    // Handle AR scanning start
    setCurrentView('home');
    setCurrentCommunityLearningView(null);
  };

  const handleSceneSelect = (sceneId) => {
    console.log('Scene selected:', sceneId);
    // Handle AR scene selection
    setCurrentView('home');
    setCurrentCommunityLearningView(null);
  };

  const renderHome = () => (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white">
      <Header 
        streak={userData.streak}
        onNotificationClick={() => setShowDailyChallenge(true)}
        onAILearningAssistantClick={handleAILearningAssistantClick}
        onOfflineModeClick={handleOfflineModeClick}
        onSettingsClick={() => setShowLanguageSettings(true)}
        onTutorVoiceClick={handleVoiceSelectorClick}
        onMenuClick={() => setShowSidebar(true)}
      />
      
      <StatsBar 
        userLevel={userData.level}
        xp={userData.xp}
        streak={userData.streak}
      />

      {/* Daily Word */}
      {dailyWord && (
        <div className="px-6 mb-6">
          <h2 className="text-lg font-semibold mb-4">
            {userPreferences.displayLanguage === 'traditional' ? '每日單詞' :
             userPreferences.displayLanguage === 'simplified' ? '每日单词' :
             'Word of the Day'}
          </h2>
          <VocabularyCard 
            word={dailyWord}
            language={userPreferences.displayLanguage}
            mode="read"
            onStudyClick={() => {
              setSelectedCategory(dailyWord.category);
              setCurrentMode('study');
              setCurrentView('learning');
            }}
            onTestClick={() => {
              setSelectedCategory(dailyWord.category);
              setCurrentMode('test');
              setCurrentView('learning');
            }}
          />
        </div>
      )}

      {/* Purchased Courses Section */}
      <PurchasedCoursesSection 
        language={userPreferences.displayLanguage}
        onCourseClick={handlePurchasedCourseClick}
      />

      {/* Categories */}
      <div className="px-6 mb-6">
        <h2 className="text-lg font-semibold mb-4">
          {userPreferences.displayLanguage === 'traditional' ? '學習分類' :
           userPreferences.displayLanguage === 'simplified' ? '学习分类' :
           'Study Categories'}
        </h2>
        <div className="grid grid-cols-2 gap-4">
          {Object.values(vocabularyCategories).map((category) => (
            <button
              key={category.id}
              onClick={() => {
                setSelectedCategory(category.id);
                setCurrentWordIndex(0);
                setCurrentView('learning');
              }}
              className={`p-4 rounded-xl bg-gradient-to-r ${category.color} text-center transition-all duration-300 ease-out hover:-translate-y-2 hover:shadow-xl active:translate-y-0`}
            >
              <div className="text-3xl mb-2">{category.icon}</div>
              <h3 className="font-semibold">
                {userPreferences.displayLanguage === 'traditional' ? category.name :
                 userPreferences.displayLanguage === 'simplified' ? category.nameSimplified :
                 category.nameEnglish}
              </h3>
              <div className="text-xs opacity-90 mt-1">
                {userProgress.vocabulary[category.id]?.learned || 0} / {vocabularyData[category.id]?.length || 0}
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Grammar Topics */}
      <div className="px-6 mb-20">
        <h2 className="text-lg font-semibold mb-4">
          {userPreferences.displayLanguage === 'traditional' ? '語法主題' :
           userPreferences.displayLanguage === 'simplified' ? '语法主题' :
           'Grammar Topics'}
        </h2>
        <div className="space-y-3">
          {/* Show a summary of comprehensive grammar groups */}
           <button
             onClick={() => {
               handleGrammarTopicsClick();
             }}
             className="w-full p-4 rounded-xl bg-gradient-to-r from-blue-600/30 to-purple-600/30 border border-blue-500/50 flex items-center space-x-4 hover:from-blue-500/40 hover:to-purple-500/40 transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-xl active:translate-y-0"
           >
            <div className="text-2xl">📚</div>
            <div className="flex-1 text-left">
              <h3 className="font-semibold">
                {userPreferences.displayLanguage === 'traditional' ? '90個核心語法結構' :
                 userPreferences.displayLanguage === 'simplified' ? '90个核心语法结构' :
                 '90 Core Grammar Structures'}
              </h3>
              <p className="text-gray-300 text-sm">
                {userPreferences.displayLanguage === 'traditional' ? '系統性學習英語語法，從基礎句型到高級結構' :
                 userPreferences.displayLanguage === 'simplified' ? '系统性学习英语语法，从基础句型到高级结构' :
                 'Systematic English grammar learning from basic patterns to advanced structures'}
              </p>
            </div>
            <div className="px-2 py-1 rounded text-xs bg-green-500/20 text-green-300">
              {userPreferences.displayLanguage === 'traditional' ? '完整課程' :
               userPreferences.displayLanguage === 'simplified' ? '完整课程' :
               'COMPLETE'}
            </div>
          </button>
          
          {/* Show some sample topics from our comprehensive data */}
           {grammarTopics.slice(0, 3).map((topic) => (
             <button
               key={topic.id}
               onClick={() => {
                 // Navigate to comprehensive grammar topics page
                 handleGrammarTopicsClick();
               }}
               className="w-full p-4 rounded-xl bg-gray-800/30 border border-gray-600 flex items-center space-x-4 transition-all duration-300 ease-out hover:-translate-y-1 hover:bg-gray-700/40 hover:border-gray-500 hover:shadow-lg active:translate-y-0"
             >
              <div className="text-2xl">{topic.icon}</div>
              <div className="flex-1 text-left">
                <h3 className="font-semibold">
                  {userPreferences.displayLanguage === 'traditional' ? topic.name :
                   userPreferences.displayLanguage === 'simplified' ? topic.nameSimplified :
                   topic.nameEnglish}
                </h3>
                <p className="text-gray-300 text-sm">
                  {userPreferences.displayLanguage === 'traditional' ? topic.description :
                   userPreferences.displayLanguage === 'simplified' ? topic.descriptionSimplified :
                   topic.descriptionEnglish}
                </p>
              </div>
              <div className={`px-2 py-1 rounded text-xs ${
                topic.difficulty === 'beginner' ? 'bg-green-500/20 text-green-300' :
                topic.difficulty === 'intermediate' ? 'bg-yellow-500/20 text-yellow-300' :
                'bg-red-500/20 text-red-300'
              }`}>
                {topic.difficulty.toUpperCase()}
              </div>
            </button>
          ))}
        </div>
      </div>

      <BottomNavigation
        currentView={currentView}
        onHomeClick={() => setCurrentView('home')}
        onLearningClick={() => setCurrentView('learning')}
        onChallengeClick={() => setShowDailyChallenge(true)}
        onSocialClick={() => setShowProgressTracker(true)}
      />

      {/* Sidebar */}
      <SidebarNav
        isOpen={showSidebar}
        onClose={() => setShowSidebar(false)}
        onSelect={handleSidebarSelect}
      />
    </div>
  );

  const renderLearning = () => (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white">
      <Header 
        streak={userData.streak}
        onNotificationClick={() => setShowDailyChallenge(true)}
        onAILearningAssistantClick={handleAILearningAssistantClick}
        onOfflineModeClick={handleOfflineModeClick}
        onSettingsClick={() => setShowLanguageSettings(true)}
        onMenuClick={() => setShowSidebar(true)}
      />

      {!selectedCategory ? (
        <ModeSelector 
          currentMode={currentMode}
          onModeChange={setCurrentMode}
          language={userPreferences.displayLanguage}
        />
      ) : (
        <div className="mb-6">
          <div className="flex items-center justify-between mb-4 px-6">
            <button 
              onClick={() => {
                setSelectedCategory(null);
                setCurrentMode('read');
              }}
              className="text-blue-400"
            >
              ← 返回分類
            </button>
            <div className="text-sm text-gray-300">
              {currentWordIndex + 1} / {currentWords.length}
            </div>
          </div>

          {currentMode === 'read' && currentWord && (
            <div className="px-6">
              <VocabularyCard 
                word={currentWord}
                language={userPreferences.displayLanguage}
                mode={currentMode}
                onStudyClick={() => setCurrentMode('study')}
                onTestClick={() => setCurrentMode('test')}
              />
              
              {/* Navigation */}
              <div className="flex justify-between mt-4">
                <button 
                  onClick={handlePrevWord}
                  disabled={currentWordIndex === 0}
                  className="px-6 py-3 bg-gray-600 rounded-lg disabled:opacity-50"
                >
                  上一個
                </button>
                <button 
                  onClick={handleNextWord}
                  disabled={currentWordIndex === currentWords.length - 1}
                  className="px-6 py-3 bg-blue-500 rounded-lg disabled:opacity-50"
                >
                  下一個
                </button>
              </div>
            </div>
          )}

          {currentMode === 'study' && currentWord && (
            <StudyMode 
              word={currentWord}
              language={userPreferences.displayLanguage}
              onComplete={() => {
                // Mark word as studied and move to next
                handleNextWord();
              }}
              onNext={handleNextWord}
            />
          )}

          {currentMode === 'test' && (
            <TestMode 
              words={currentWords}
              language={userPreferences.displayLanguage}
              onComplete={(score, timeTaken) => {
                // Save test results
                console.log('Test completed:', { score, timeTaken });
                setCurrentMode('read');
              }}
            />
          )}
        </div>
      )}

      <div className="pb-20"></div>

      <BottomNavigation
        currentView={currentView}
        onHomeClick={() => setCurrentView('home')}
        onLearningClick={() => setCurrentView('learning')}
        onChallengeClick={() => setShowDailyChallenge(true)}
        onSocialClick={() => setShowProgressTracker(true)}
      />

      {/* Sidebar */}
      <SidebarNav
        isOpen={showSidebar}
        onClose={() => setShowSidebar(false)}
        onSelect={handleSidebarSelect}
      />
    </div>
  );

  return (
    <div className="max-w-sm mx-auto bg-gray-900 relative">
      {currentView === 'home' && renderHome()}
      {currentView === 'learning' && renderLearning()}
      {currentView === 'learning_journey' && (
        <LearningJourneyPage
          language={userPreferences.displayLanguage}
          onBack={() => setCurrentView('home')}
          onOpen={handleOpenComponent}
        />
      )}
      {currentView === 'components' && (
        <ComponentsCatalogPage
          language={userPreferences.displayLanguage}
          onBack={() => setCurrentView('home')}
          onOpen={handleOpenComponent}
        />
      )}
             {currentView === 'learning_path' && (
         <LearningPathPage
           userId="peter"
           language={userPreferences.displayLanguage}
           onBack={handleBackFromLearningPath}
           onUnitClick={handleUnitClick}
         />
       )}
       {currentView === 'unit_studying' && (
         <UnitStudyingPage
           onBack={handleBackFromUnitStudying}
           onLessonClick={handleLessonClick}
           userPreferences={userPreferences}
         />
       )}
      {currentView === 'unit_detail' && selectedUnitId && (
        <UnitDetailPage
          unitId={selectedUnitId}
          language={userPreferences.displayLanguage}
          onBack={handleBackFromUnitDetail}
          onLessonClick={handleLessonClick}
        />
      )}
      {currentView === 'roleplay' && (
        <RoleplayPage
          onBack={handleBackFromRoleplay}
          onScenarioClick={handleScenarioClick}
          onLabOptionClick={handleLabOptionClick}
          userPreferences={userPreferences}
        />
      )}
      {currentView === 'roleplay_scenario' && (
        <RoleplayScenarioPage
          scenarioId={selectedScenarioId}
          language={userPreferences.displayLanguage}
          onBack={handleBackFromRoleplayScenario}
          onStartRoleplay={handleStartRoleplay}
        />
      )}
      {currentView === 'tutor_voice' && (
        <TutorVoicePage
          language={userPreferences.displayLanguage}
          onBack={handleBackFromTutorVoice}
          onSave={handleSaveTutorVoice}
        />
      )}
      {currentView === 'tone_learning_units' && (
        <ToneLearningUnitsPage
          language={userPreferences.displayLanguage}
          onBack={handleBackFromToneLearningUnits}
          onUnitClick={handleToneUnitClick}
        />
      )}
      {currentView === 'tone_unit_detail' && selectedToneUnitId && (
        <ToneUnitDetailPage
          unitId={selectedToneUnitId}
          language={userPreferences.displayLanguage}
          onBack={handleBackFromToneUnitDetail}
          onLessonClick={handleToneLessonClick}
        />
      )}
      {currentView === 'bilingual_tutor' && (
        <BilingualTutorPage
          language={userPreferences.displayLanguage}
          onBack={handleBackFromBilingualTutor}
          onSessionClick={handleBilingualSessionClick}
        />
      )}
      {currentView === 'bilingual_tutor_session' && selectedBilingualSessionId && (
        <BilingualTutorSessionPage
          sessionId={selectedBilingualSessionId}
          language={userPreferences.displayLanguage}
          onBack={handleBackFromBilingualSession}
          onSessionComplete={handleBilingualSessionComplete}
        />
      )}
      
      {/* Learning Cycle Views */}
      {currentView === 'learning_cycle' && currentLearningCycleView === 'cycle' && (
        <LearningCyclePage
          language={userPreferences.displayLanguage}
          onBack={handleBackFromLearningCycle}
          onViewPackages={handleViewPackages}
        />
      )}
      
      {currentView === 'learning_cycle' && currentLearningCycleView === 'packages' && (
        <LearningPackagesPage
          language={userPreferences.displayLanguage}
          onBack={handleBackFromPackages}
          onViewAIFeedback={handleViewAIFeedback}
          onViewCertifiedCourses={handleViewCertifiedCourses}
        />
      )}
      
      {currentView === 'learning_cycle' && currentLearningCycleView === 'ai_feedback' && (
        <AIFeedbackPage
          language={userPreferences.displayLanguage}
          onBack={handleBackFromAIFeedback}
          onKeepGoing={handleKeepGoing}
        />
      )}
      
             {currentView === 'learning_cycle' && currentLearningCycleView === 'certified_courses' && (
         <CertifiedCoursesPage
           language={userPreferences.displayLanguage}
           onBack={handleBackFromCertifiedCourses}
           onStartTraining={handleStartTraining}
         />
       )}
       
       {/* Daily Challenges Views */}
       {currentView === 'daily_challenges' && currentDailyChallengesView === 'challenges' && (
         <DailyChallengesPage
           language={userPreferences.displayLanguage}
           onBack={handleBackFromDailyChallenges}
           onLeaderboardClick={handleLeaderboardClick}
           onAchievementsClick={handleAchievementsClick}
           onChallengeStart={handleChallengeStart}
         />
       )}
       
               {currentView === 'daily_challenges' && currentDailyChallengesView === 'achievements' && (
          <AchievementsPage
            language={userPreferences.displayLanguage}
            onBack={handleBackFromAchievements}
            onShareAchievement={handleShareAchievement}
          />
        )}
        
        {/* Standalone Community Learning Page */}
        {currentView === 'community_learning' && (
          <CommunityLearningPage
            onBack={handleBackFromCommunityLearning}
            userPreferences={userPreferences}
          />
        )}
        


        {/* Standalone AR Practice Page */}
        {currentView === 'ar_practice' && (
          <ARPracticePage
            onBack={handleBackFromStandaloneARPractice}
            userPreferences={userPreferences}
          />
        )}

        {/* Grammar Topics Page */}
        {currentView === 'grammar_topics' && (
          <GrammarTopicsPage
            onBack={handleBackFromGrammarTopics}
            userPreferences={userPreferences}
            onNavigateToTopic={handleNavigateToGrammarTopic}
          />
        )}

        {/* Grammar Topic Learning Page */}
        {currentView === 'grammar_topic_learning' && currentGrammarGroupId && currentGrammarTopicId && (
          <GrammarTopicLearningPage
            onBack={handleBackFromGrammarTopicLearning}
            userPreferences={userPreferences}
            groupId={currentGrammarGroupId}
            topicId={currentGrammarTopicId}
            mode={currentGrammarMode}
            onModeChange={handleGrammarModeChange}
          />
        )}

        {/* Purchased Course Pages */}
        {currentView === 'purchased_course' && currentPurchasedCourse === 'grammar_book' && (
          <GrammarBookPage
            onBack={handleBackFromPurchasedCourse}
            userPreferences={userPreferences}
          />
        )}
        
        {currentView === 'purchased_course' && currentPurchasedCourse === 'ielts_study' && (
          <IELTSStudyPage
            onBack={handleBackFromPurchasedCourse}
            userPreferences={userPreferences}
          />
        )}
        
        {currentView === 'purchased_course' && currentPurchasedCourse === 'toefl_study' && (
          <TOEFLStudyPage
            onBack={handleBackFromPurchasedCourse}
            userPreferences={userPreferences}
          />
        )}
        
        {currentView === 'purchased_course' && currentPurchasedCourse === 'my_school_book' && (
          <MySchoolBookPage
            onBack={handleBackFromPurchasedCourse}
            userPreferences={userPreferences}
          />
        )}
      
      <LanguageSettings 
        isOpen={showLanguageSettings}
        onClose={() => setShowLanguageSettings(false)}
        preferences={userPreferences}
        onPreferencesChange={handlePreferencesChange}
      />

      {showDailyChallenge && (
        <DailyChallenge 
          isOpen={showDailyChallenge}
          onClose={() => setShowDailyChallenge(false)}
          challenges={dailyChallenges}
          userProgress={userProgress}
          language={userPreferences.displayLanguage}
        />
      )}

      {showProgressTracker && (
        <ProgressTracker 
          isOpen={showProgressTracker}
          onClose={() => setShowProgressTracker(false)}
          userProgress={userProgress}
          language={userPreferences.displayLanguage}
        />
      )}

      {showAILearningAssistant && (
        <AILearningAssistantPage
          onBack={handleBackFromAILearningAssistant}
          userPreferences={userPreferences}
        />
      )}

      {showVoiceQualityTester && (
        <VoiceQualityTester onBack={handleBackFromVoiceQualityTester} />
      )}

      {showVoiceSelector && (
        <VoiceSelector
          isOpen={showVoiceSelector}
          onClose={handleVoiceSelectorClose}
          onVoiceChange={handleVoiceChange}
        />
      )}

      {showOfflineLearning && (
        <OfflineLearningPage
          onBack={handleBackFromOfflineLearning}
          userPreferences={userPreferences}
        />
      )}

      {showTutorVoiceSelection && (
        <TutorVoiceSelectionPage
          onBack={handleBackFromTutorVoiceSelection}
          onSave={handleSaveTutorVoice}
          userPreferences={userPreferences}
        />
      )}

      {/* Voice selection is now handled by VoiceSelector component */}
      
      {/* A2A Server Toggle */}
      <A2AServerToggle />
    </div>
  );
}

export default App;
